module.exports = __webpack_public_path__ + "img/Window.0e08adb9.jpg";